import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { API_URL } from "../apiConfig";
import { motion } from "framer-motion";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { courses } from "../data/courses";

// ICONS
import { FaClock, FaMoneyBillWave, FaUserTie, FaDownload } from "react-icons/fa";
import { IoMdCheckmarkCircle } from "react-icons/io";

// Register GSAP plugins
if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

// 🔢 Static schedule data for Metal Scaffold Level 1 - December 2025
const metalScaffoldLevel1ScheduleDecember = [
  { date: "16-12-2025", pax: 4, vacancy: 4 },
  { date: "16-12-2025", pax: 4, vacancy: 4 },
  { date: "17-12-2025", pax: 4, vacancy: 4 },
  { date: "17-12-2025", pax: 4, vacancy: 4 },
  { date: "18-12-2025", pax: 4, vacancy: 4 },
  { date: "18-12-2025", pax: 4, vacancy: 4 },
  { date: "19-12-2025", pax: 4, vacancy: 4 },
  { date: "19-12-2025", pax: 4, vacancy: 4 },
  { date: "20-12-2025", pax: 4, vacancy: 4 },
  { date: "20-12-2025", pax: 4, vacancy: 4 },
  { date: "22-12-2025", pax: 4, vacancy: 4 },
  { date: "22-12-2025", pax: 4, vacancy: 4 },
  { date: "23-12-2025", pax: 4, vacancy: 4 },
  { date: "23-12-2025", pax: 4, vacancy: 4 },
  { date: "24-12-2025", pax: 4, vacancy: 4 },
  { date: "24-12-2025", pax: 4, vacancy: 4 },
  { date: "26-12-2025", pax: 4, vacancy: 4 },
  { date: "26-12-2025", pax: 4, vacancy: 4 },
  { date: "27-12-2025", pax: 4, vacancy: 4 },
  { date: "27-12-2025", pax: 4, vacancy: 4 },
  { date: "29-12-2025", pax: 4, vacancy: 4 },
  { date: "29-12-2025", pax: 4, vacancy: 4 },
  { date: "30-12-2025", pax: 4, vacancy: 4 },
  { date: "30-12-2025", pax: 4, vacancy: 4 },
  { date: "31-12-2025", pax: 4, vacancy: 4 },
  { date: "31-12-2025", pax: 4, vacancy: 4 },
];

// 🔢 Static schedule data for Metal Scaffold Level 1 - January 2026 (52 Schedules)
const metalScaffoldLevel1ScheduleJanuary = [
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-02", startDate: "2026-01-02", endDate: "2026-01-02", day: "Friday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-02", assessmentDay: "Friday", assessmentTiming: "1600 to 1700 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-02", startDate: "2026-01-02", endDate: "2026-01-02", day: "Friday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-02", assessmentDay: "Friday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-03", startDate: "2026-01-03", endDate: "2026-01-03", day: "Saturday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-03", assessmentDay: "Saturday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-03", startDate: "2026-01-03", endDate: "2026-01-03", day: "Saturday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-03", assessmentDay: "Saturday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-05", startDate: "2026-01-05", endDate: "2026-01-05", day: "Monday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-05", assessmentDay: "Monday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-05", startDate: "2026-01-05", endDate: "2026-01-05", day: "Monday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-05", assessmentDay: "Monday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-06", startDate: "2026-01-06", endDate: "2026-01-06", day: "Tuesday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-06", assessmentDay: "Tuesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-06", startDate: "2026-01-06", endDate: "2026-01-06", day: "Tuesday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-06", assessmentDay: "Tuesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-07", startDate: "2026-01-07", endDate: "2026-01-07", day: "Wednesday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-07", assessmentDay: "Wednesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-07", startDate: "2026-01-07", endDate: "2026-01-07", day: "Wednesday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-07", assessmentDay: "Wednesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-08", startDate: "2026-01-08", endDate: "2026-01-08", day: "Thursday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-08", assessmentDay: "Thursday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-08", startDate: "2026-01-08", endDate: "2026-01-08", day: "Thursday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-08", assessmentDay: "Thursday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-09", startDate: "2026-01-09", endDate: "2026-01-09", day: "Friday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-09", assessmentDay: "Friday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-09", startDate: "2026-01-09", endDate: "2026-01-09", day: "Friday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-09", assessmentDay: "Friday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-10", startDate: "2026-01-10", endDate: "2026-01-10", day: "Saturday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-10", assessmentDay: "Saturday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-10", startDate: "2026-01-10", endDate: "2026-01-10", day: "Saturday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-10", assessmentDay: "Saturday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-12", startDate: "2026-01-12", endDate: "2026-01-12", day: "Monday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-12", assessmentDay: "Monday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-12", startDate: "2026-01-12", endDate: "2026-01-12", day: "Monday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-12", assessmentDay: "Monday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-13", startDate: "2026-01-13", endDate: "2026-01-13", day: "Tuesday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-13", assessmentDay: "Tuesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-13", startDate: "2026-01-13", endDate: "2026-01-13", day: "Tuesday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-13", assessmentDay: "Tuesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-14", startDate: "2026-01-14", endDate: "2026-01-14", day: "Wednesday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-14", assessmentDay: "Wednesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-14", startDate: "2026-01-14", endDate: "2026-01-14", day: "Wednesday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-14", assessmentDay: "Wednesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-15", startDate: "2026-01-15", endDate: "2026-01-15", day: "Thursday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-15", assessmentDay: "Thursday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-15", startDate: "2026-01-15", endDate: "2026-01-15", day: "Thursday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-15", assessmentDay: "Thursday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-16", startDate: "2026-01-16", endDate: "2026-01-16", day: "Friday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-16", assessmentDay: "Friday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-16", startDate: "2026-01-16", endDate: "2026-01-16", day: "Friday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-16", assessmentDay: "Friday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-17", startDate: "2026-01-17", endDate: "2026-01-17", day: "Saturday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-17", assessmentDay: "Saturday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-17", startDate: "2026-01-17", endDate: "2026-01-17", day: "Saturday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-17", assessmentDay: "Saturday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-19", startDate: "2026-01-19", endDate: "2026-01-19", day: "Monday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-19", assessmentDay: "Monday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-19", startDate: "2026-01-19", endDate: "2026-01-19", day: "Monday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-19", assessmentDay: "Monday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-20", startDate: "2026-01-20", endDate: "2026-01-20", day: "Tuesday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-20", assessmentDay: "Tuesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-20", startDate: "2026-01-20", endDate: "2026-01-20", day: "Tuesday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-20", assessmentDay: "Tuesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-21", startDate: "2026-01-21", endDate: "2026-01-21", day: "Wednesday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-21", assessmentDay: "Wednesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-21", startDate: "2026-01-21", endDate: "2026-01-21", day: "Wednesday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-21", assessmentDay: "Wednesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-22", startDate: "2026-01-22", endDate: "2026-01-22", day: "Thursday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-22", assessmentDay: "Thursday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-22", startDate: "2026-01-22", endDate: "2026-01-22", day: "Thursday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-22", assessmentDay: "Thursday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-23", startDate: "2026-01-23", endDate: "2026-01-23", day: "Friday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-23", assessmentDay: "Friday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-23", startDate: "2026-01-23", endDate: "2026-01-23", day: "Friday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-23", assessmentDay: "Friday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-24", startDate: "2026-01-24", endDate: "2026-01-24", day: "Saturday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-24", assessmentDay: "Saturday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-24", startDate: "2026-01-24", endDate: "2026-01-24", day: "Saturday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-24", assessmentDay: "Saturday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-26", startDate: "2026-01-26", endDate: "2026-01-26", day: "Monday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-26", assessmentDay: "Monday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-26", startDate: "2026-01-26", endDate: "2026-01-26", day: "Monday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-26", assessmentDay: "Monday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-27", startDate: "2026-01-27", endDate: "2026-01-27", day: "Tuesday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-27", assessmentDay: "Tuesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-27", startDate: "2026-01-27", endDate: "2026-01-27", day: "Tuesday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-27", assessmentDay: "Tuesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-28", startDate: "2026-01-28", endDate: "2026-01-28", day: "Wednesday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-28", assessmentDay: "Wednesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-28", startDate: "2026-01-28", endDate: "2026-01-28", day: "Wednesday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-28", assessmentDay: "Wednesday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-29", startDate: "2026-01-29", endDate: "2026-01-29", day: "Thursday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-29", assessmentDay: "Thursday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-29", startDate: "2026-01-29", endDate: "2026-01-29", day: "Thursday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-29", assessmentDay: "Thursday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-30", startDate: "2026-01-30", endDate: "2026-01-30", day: "Friday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-30", assessmentDay: "Friday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-30", startDate: "2026-01-30", endDate: "2026-01-30", day: "Friday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-30", assessmentDay: "Friday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-31", startDate: "2026-01-31", endDate: "2026-01-31", day: "Saturday", trainingTime: "0800 to 1600 (2 hrs)", assessmentDate: "2026-01-31", assessmentDay: "Saturday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
  { courseTitle: "CoC in Metal Scaffolding – Level 1", reservedFor: "Greenmark Construction Pte Ltd", duration: 7, applicants: 4, trainingDate: "2026-01-31", startDate: "2026-01-31", endDate: "2026-01-31", day: "Saturday", trainingTime: "1400 to 1600 (2 hrs)", assessmentDate: "2026-01-31", assessmentDay: "Saturday", assessmentTiming: "1600 to 2100 (1 hr)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Greenmark Construction Pte Ltd" },
];

// Keep old data for backward compatibility
const metalScaffoldLevel1Schedule = metalScaffoldLevel1ScheduleDecember;

// 🔢 Static schedule data for Welding Level 1 - December 2025
const WeldingLevel1ScheduleDecember = [
  { date: "15-12-2025", pax: 10, vacancy: 5 },
  { date: "16-12-2025", pax: 10, vacancy: 10 },
  { date: "19-12-2025", pax: 10, vacancy: 1 },
  { date: "21-12-2025", pax: 10, vacancy: 0 },
];

// 🔢 Static schedule data for Welding Level 1 - January 2026
const WeldingLevel1Schedule = [
  {
    courseTitle: "CoC in Welding – Level 1",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 7,
    applicants: 10,
    trainingDate: "05-01-2026",
    startDate: "2026-01-05",
    endDate: "2026-01-05",
    day: "Monday",
    trainingTime: "08:00–10:00 (2 hrs)",
    assessmentDate: "2026-01-05",
    assessmentDay: "Monday",
    assessmentTiming: "10:00–15:00 (5 hrs)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 1",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 7,
    applicants: 10,
    trainingDate: "08-01-2026",
    startDate: "2026-01-08",
    endDate: "2026-01-08",
    day: "Thursday",
    trainingTime: "08:00–10:00 (2 hrs)",
    assessmentDate: "2026-01-08",
    assessmentDay: "Thursday",
    assessmentTiming: "10:00–15:00 (5 hrs)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 1",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 7,
    applicants: 10,
    trainingDate: "12-01-2026",
    startDate: "2026-01-12",
    endDate: "2026-01-12",
    day: "Monday",
    trainingTime: "08:00–10:00 (2 hrs)",
    assessmentDate: "2026-01-12",
    assessmentDay: "Monday",
    assessmentTiming: "10:00–15:00 (5 hrs)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 1",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 7,
    applicants: 10,
    trainingDate: "15-01-2026",
    startDate: "2026-01-15",
    endDate: "2026-01-15",
    day: "Thursday",
    trainingTime: "08:00–10:00 (2 hrs)",
    assessmentDate: "2026-01-15",
    assessmentDay: "Thursday",
    assessmentTiming: "10:00–15:00 (5 hrs)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 1",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 7,
    applicants: 10,
    trainingDate: "19-01-2026",
    startDate: "2026-01-19",
    endDate: "2026-01-19",
    day: "Monday",
    trainingTime: "08:00–10:00 (2 hrs)",
    assessmentDate: "2026-01-19",
    assessmentDay: "Monday",
    assessmentTiming: "10:00–15:00 (5 hrs)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 1",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 7,
    applicants: 10,
    trainingDate: "22-01-2026",
    startDate: "2026-01-22",
    endDate: "2026-01-22",
    day: "Thursday",
    trainingTime: "08:00–10:00 (2 hrs)",
    assessmentDate: "2026-01-22",
    assessmentDay: "Thursday",
    assessmentTiming: "10:00–15:00 (5 hrs)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 1",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 7,
    applicants: 10,
    trainingDate: "26-01-2026",
    startDate: "2026-01-26",
    endDate: "2026-01-26",
    day: "Monday",
    trainingTime: "08:00–10:00 (2 hrs)",
    assessmentDate: "2026-01-26",
    assessmentDay: "Monday",
    assessmentTiming: "10:00–15:00 (5 hrs)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 1",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 7,
    applicants: 10,
    trainingDate: "29-01-2026",
    startDate: "2026-01-29",
    endDate: "2026-01-29",
    day: "Thursday",
    trainingTime: "08:00–10:00 (2 hrs)",
    assessmentDate: "2026-01-29",
    assessmentDay: "Thursday",
    assessmentTiming: "10:00–15:00 (5 hrs)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  }
];

// 🔢 Static schedule data for Welding Level 2 (currently empty)
const WeldingLevel2Schedule = [];

// 🔢 Static schedule data for Welding Level 2 - December 2025
const WeldingLevel2ScheduleDecember = [];

// 🔢 Static schedule data for Welding Level 2 - January 2026
const WeldingLevel2ScheduleJanuary = [
  {
    courseTitle: "CoC in Welding – Level 2",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 21,
    applicants: 10,
    trainingDate: "05 Jan to 07 Jan",
    startDate: "2026-01-05",
    endDate: "2026-01-07",
    days: "Monday & Tuesday",
    trainingTime: "04:00–19:00 (8 hrs / 45 mins)",
    assessmentDate: "2026-01-07",
    assessmentDay: "Wednesday",
    assessmentTiming: "15:00–18:15 (3 hrs 15 mins)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 2",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 21,
    applicants: 10,
    trainingDate: "08 Jan to 10 Jan",
    startDate: "2026-01-08",
    endDate: "2026-01-10",
    days: "Thursday & Friday",
    trainingTime: "04:00–19:00 (8 hrs / 45 mins)",
    assessmentDate: "2026-01-10",
    assessmentDay: "Saturday",
    assessmentTiming: "15:00–18:15 (3 hrs 15 mins)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 2",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 21,
    applicants: 10,
    trainingDate: "12 Jan to 14 Jan",
    startDate: "2026-01-12",
    endDate: "2026-01-14",
    days: "Monday & Tuesday",
    trainingTime: "04:00–19:00 (8 hrs / 45 mins)",
    assessmentDate: "2026-01-14",
    assessmentDay: "Wednesday",
    assessmentTiming: "15:00–18:15 (3 hrs 15 mins)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 2",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 21,
    applicants: 10,
    trainingDate: "15 Jan to 17 Jan",
    startDate: "2026-01-15",
    endDate: "2026-01-17",
    days: "Thursday & Friday",
    trainingTime: "04:00–19:00 (8 hrs / 45 mins)",
    assessmentDate: "2026-01-17",
    assessmentDay: "Saturday",
    assessmentTiming: "15:00–18:15 (3 hrs 15 mins)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 2",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 21,
    applicants: 10,
    trainingDate: "19 Jan to 21 Jan",
    startDate: "2026-01-19",
    endDate: "2026-01-21",
    days: "Monday & Tuesday",
    trainingTime: "04:00–19:00 (8 hrs / 45 mins)",
    assessmentDate: "2026-01-21",
    assessmentDay: "Wednesday",
    assessmentTiming: "15:00–18:15 (3 hrs 15 mins)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 2",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 21,
    applicants: 10,
    trainingDate: "22 Jan to 24 Jan",
    startDate: "2026-01-22",
    endDate: "2026-01-24",
    days: "Thursday & Friday",
    trainingTime: "04:00–19:00 (8 hrs / 45 mins)",
    assessmentDate: "2026-01-24",
    assessmentDay: "Saturday",
    assessmentTiming: "15:00–18:15 (3 hrs 15 mins)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 2",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 21,
    applicants: 10,
    trainingDate: "26 Jan to 28 Jan",
    startDate: "2026-01-26",
    endDate: "2026-01-28",
    days: "Monday & Tuesday",
    trainingTime: "04:00–19:00 (8 hrs / 45 mins)",
    assessmentDate: "2026-01-28",
    assessmentDay: "Wednesday",
    assessmentTiming: "15:00–18:15 (3 hrs 15 mins)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  },
  {
    courseTitle: "CoC in Welding – Level 2",
    reservedFor: "Greenmark Construction Pte Ltd",
    duration: 21,
    applicants: 10,
    trainingDate: "29 Jan to 31 Jan",
    startDate: "2026-01-29",
    endDate: "2026-01-31",
    days: "Thursday & Friday",
    trainingTime: "04:00–19:00 (8 hrs / 45 mins)",
    assessmentDate: "2026-01-31",
    assessmentDay: "Saturday",
    assessmentTiming: "15:00–18:15 (3 hrs 15 mins)",
    trainingVenue: "Greenmark Construction Pte Ltd",
    trainerName: "Vanagalli Ravikumar"
  }
];

// 🔢 Static schedule data for Metal Scaffold Level 2 - December 2025
const metalScaffoldLevel2ScheduleDecember = [
  { date: "15/12/2025 to 16/12/2025", pax: 4, vacancy: 4 },
  { date: "15/12/2025 to 16/12/2025", pax: 4, vacancy: 4 },
  { date: "15/12/2025 to 16/12/2025", pax: 4, vacancy: 4 },
  { date: "17/12/2025 to 18/12/2025", pax: 4, vacancy: 4 },
  { date: "17/12/2025 to 18/12/2025", pax: 4, vacancy: 4 },
  { date: "17/12/2025 to 18/12/2025", pax: 4, vacancy: 4 },
  { date: "19/12/2025 to 20/12/2025", pax: 4, vacancy: 4 },
  { date: "19/12/2025 to 20/12/2025", pax: 4, vacancy: 4 },
  { date: "19/12/2025 to 20/12/2025", pax: 4, vacancy: 4 },
  { date: "21/12/2025 to 22/12/2025", pax: 4, vacancy: 4 },
  { date: "21/12/2025 to 22/12/2025", pax: 4, vacancy: 4 },
  { date: "21/12/2025 to 22/12/2025", pax: 4, vacancy: 4 },
  { date: "23/12/2025 to 24/12/2025", pax: 4, vacancy: 4 },
  { date: "23/12/2025 to 24/12/2025", pax: 4, vacancy: 4 },
  { date: "23/12/2025 to 24/12/2025", pax: 4, vacancy: 4 },
  { date: "25/12/2025 to 26/12/2025", pax: 4, vacancy: 4 },
  { date: "25/12/2025 to 26/12/2025", pax: 4, vacancy: 4 },
  { date: "25/12/2025 to 26/12/2025", pax: 4, vacancy: 4 },
  { date: "27/12/2025 to 28/12/2025", pax: 4, vacancy: 4 },
  { date: "27/12/2025 to 28/12/2025", pax: 4, vacancy: 4 },
  { date: "27/12/2025 to 28/12/2025", pax: 4, vacancy: 4 },
  { date: "29/12/2025 to 30/12/2025", pax: 4, vacancy: 4 },
  { date: "29/12/2025 to 30/12/2025", pax: 4, vacancy: 4 },
  { date: "29/12/2025 to 30/12/2025", pax: 4, vacancy: 4 },
  { date: "31/12/2025 to 01/01/2026", pax: 4, vacancy: 4 },
  { date: "31/12/2025 to 01/01/2026", pax: 4, vacancy: 4 },
  { date: "31/12/2025 to 01/01/2026", pax: 4, vacancy: 4 },
  { date: "02/01/2026 to 03/01/2026", pax: 4, vacancy: 4 },
  { date: "02/01/2026 to 03/01/2026", pax: 4, vacancy: 4 },
  { date: "02/01/2026 to 03/01/2026", pax: 4, vacancy: 4 },
];

// 🔢 Static schedule data for Metal Scaffold Level 2 - January 2026 (Detailed)
const metalScaffoldLevel2ScheduleJanuary = [
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "05 Jan to 06 Jan", startDate: "2026-01-05", endDate: "2026-01-06", day: "Monday / Tuesday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-06", assessmentDay: "Tuesday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "05 Jan to 06 Jan", startDate: "2026-01-05", endDate: "2026-01-06", day: "Monday / Tuesday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-06", assessmentDay: "Tuesday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "07 Jan to 08 Jan", startDate: "2026-01-07", endDate: "2026-01-08", day: "Wednesday / Thursday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-08", assessmentDay: "Thursday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "07 Jan to 08 Jan", startDate: "2026-01-07", endDate: "2026-01-08", day: "Wednesday / Thursday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-08", assessmentDay: "Thursday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "09 Jan to 10 Jan", startDate: "2026-01-09", endDate: "2026-01-10", day: "Friday / Saturday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-10", assessmentDay: "Saturday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "09 Jan to 10 Jan", startDate: "2026-01-09", endDate: "2026-01-10", day: "Friday / Saturday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-10", assessmentDay: "Saturday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "12 Jan to 13 Jan", startDate: "2026-01-12", endDate: "2026-01-13", day: "Monday / Tuesday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-13", assessmentDay: "Tuesday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "12 Jan to 13 Jan", startDate: "2026-01-12", endDate: "2026-01-13", day: "Monday / Tuesday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-13", assessmentDay: "Tuesday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "14 Jan to 15 Jan", startDate: "2026-01-14", endDate: "2026-01-15", day: "Wednesday / Thursday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-15", assessmentDay: "Thursday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "14 Jan to 15 Jan", startDate: "2026-01-14", endDate: "2026-01-15", day: "Wednesday / Thursday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-15", assessmentDay: "Thursday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "16 Jan to 17 Jan", startDate: "2026-01-16", endDate: "2026-01-17", day: "Friday / Saturday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-17", assessmentDay: "Saturday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "16 Jan to 17 Jan", startDate: "2026-01-16", endDate: "2026-01-17", day: "Friday / Saturday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-17", assessmentDay: "Saturday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "19 Jan to 20 Jan", startDate: "2026-01-19", endDate: "2026-01-20", day: "Monday / Tuesday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-20", assessmentDay: "Tuesday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "19 Jan to 20 Jan", startDate: "2026-01-19", endDate: "2026-01-20", day: "Monday / Tuesday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-20", assessmentDay: "Tuesday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "21 Jan to 22 Jan", startDate: "2026-01-21", endDate: "2026-01-22", day: "Wednesday / Thursday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-22", assessmentDay: "Thursday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "21 Jan to 22 Jan", startDate: "2026-01-21", endDate: "2026-01-22", day: "Wednesday / Thursday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-22", assessmentDay: "Thursday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "23 Jan to 24 Jan", startDate: "2026-01-23", endDate: "2026-01-24", day: "Friday / Saturday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-24", assessmentDay: "Saturday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "23 Jan to 24 Jan", startDate: "2026-01-23", endDate: "2026-01-24", day: "Friday / Saturday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-24", assessmentDay: "Saturday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "26 Jan to 27 Jan", startDate: "2026-01-26", endDate: "2026-01-27", day: "Monday / Tuesday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-27", assessmentDay: "Tuesday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "26 Jan to 27 Jan", startDate: "2026-01-26", endDate: "2026-01-27", day: "Monday / Tuesday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-27", assessmentDay: "Tuesday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "28 Jan to 29 Jan", startDate: "2026-01-28", endDate: "2026-01-29", day: "Wednesday / Thursday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-29", assessmentDay: "Thursday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "28 Jan to 29 Jan", startDate: "2026-01-28", endDate: "2026-01-29", day: "Wednesday / Thursday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-29", assessmentDay: "Thursday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "30 Jan to 31 Jan", startDate: "2026-01-30", endDate: "2026-01-31", day: "Friday / Saturday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-31", assessmentDay: "Saturday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Ramasamy Ramkumar", status: "To be assigned" },
  { courseTitle: "CoC in Metal Scaffolding – Level 2", reservedFor: "Greenmark Construction Pte Ltd", duration: 21, applicants: 4, trainingDate: "30 Jan to 31 Jan", startDate: "2026-01-30", endDate: "2026-01-31", day: "Friday / Saturday", trainingTime: "08:00–20:00 (11 hrs)", assessmentDate: "2026-01-31", assessmentDay: "Saturday", assessmentTiming: "12:00–19:00 (7 hrs)", trainingVenue: "Greenmark Construction Pte Ltd", trainerName: "Pathanjali Kumar", status: "To be assigned" },
];

// Keep old data for backward compatibility
const metalScaffoldLevel2Schedule = metalScaffoldLevel2ScheduleDecember;

export default function CourseDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [profiles, setProfiles] = useState([]);

  // Find course from static courses list, or map api-X id dynamically
  let resolvedCourse = courses.find((c) => c.id === id);
  if (!resolvedCourse && id && id.startsWith("api-") && profiles.length > 0) {
    const apiIndex = parseInt(id.replace("api-", ""));
    const apiCourse = profiles[apiIndex];
    if (apiCourse) {
      const apiTitle = (apiCourse.course_title || "").toLowerCase();
      let localId = "101"; // default
      if (apiTitle.includes("scaffold")) localId = "101";
      else if (apiTitle.includes("welding")) localId = "102";
      else if (apiTitle.includes("electrical")) localId = "103";
      else if (apiTitle.includes("rigging") || apiTitle.includes("signalling")) localId = "104";
      
      resolvedCourse = courses.find((c) => c.id === localId);
    }
  }
  const course = resolvedCourse;

  const [selectedLevel, setSelectedLevel] = useState("level1");
  const [price, setPrice] = useState(0);
  const [duration, setDuration] = useState("");
  const [iteTitle, setIteTitle] = useState("");
  const [prerequisites, setPrerequisites] = useState("");
  const [classRatio, setClassRatio] = useState("");
  const [modeOfTraining, setModeOfTraining] = useState("");
  const [language, setLanguage] = useState("");
  const [classSchedule, setClassSchedule] = useState("");

  const [selectedMonth, setSelectedMonth] = useState("january"); // For Welding schedule months

  const [schedules, setSchedules] = useState([]);
  const [loadingSchedules, setLoadingSchedules] = useState(false);

  useEffect(() => {
    setLoadingSchedules(true);
    fetch(`${API_URL}?schedules=1&t=${Date.now()}`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setSchedules(data.filter(s => s.registration_status !== 'Unpublished Registration'));
        } else if (data && Array.isArray(data.schedules)) {
          setSchedules(data.schedules.filter(s => s.registration_status !== 'Unpublished Registration'));
        }
        setLoadingSchedules(false);
      })
      .catch((err) => {
        console.error("Error fetching schedules:", err);
        setLoadingSchedules(false);
      });
  }, []);

  useEffect(() => {
    fetch(API_URL)
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : data.data || [];
        setProfiles(list);
      })
      .catch((err) => console.error("Error fetching course profiles:", err));
  }, []);

  // Sync selectedLevel if route is api-X
  useEffect(() => {
    if (id && id.startsWith("api-") && profiles.length > 0) {
      const apiIndex = parseInt(id.replace("api-", ""));
      const apiCourse = profiles[apiIndex];
      if (apiCourse) {
        const apiTitle = (apiCourse.course_title || "").toLowerCase();
        if (apiTitle.includes("level 2") || apiTitle.includes("l2")) {
          setSelectedLevel("level2");
        } else {
          setSelectedLevel("level1");
        }
      }
    }
  }, [id, profiles]);

  const formatDateString = (dateStr) => {
    if (!dateStr) return "TBC";
    try {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      return date.toLocaleDateString("en-SG", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch (e) {
      return dateStr;
    }
  };

  const formatTime = (schedule) => {
    if (!schedule) return "9:00 AM - 5:00 PM";
    const start = schedule.am_start_time || schedule.pm_start_time || schedule.night_start_time;
    const end = schedule.night_end_time || schedule.pm_end_time || schedule.am_end_time;
    if (!start) return "9:00 AM - 5:00 PM";
    const convert = (t) => {
      if (!t) return "";
      const [hStr, mStr] = t.split(":");
      const h = parseInt(hStr);
      if (isNaN(h)) return t;
      const ampm = h >= 12 ? "PM" : "AM";
      const displayH = h % 12 === 0 ? 12 : h % 12;
      return `${displayH}:${mStr || "00"} ${ampm}`;
    };
    const startDisp = convert(start);
    const endDisp = convert(end || "17:00");
    return `${startDisp} - ${endDisp}`;
  };

  const getFilteredSchedules = (lvl) => {
    if (!course) return [];
    let filtered = [];
    const title = course.title || "";
    const isMS = title.toLowerCase().includes("scaffold") || course.id === "101";
    const isWeld = title.toLowerCase().includes("welding") || course.id === "102";
    const isEF = title.toLowerCase().includes("electrical") || course.id === "103";
    const targetLevelStr = lvl === "level1" ? "Level 1" : "Level 2";

    if (isMS) {
      filtered = schedules.filter(s => 
        s.course_title.toLowerCase().includes("scaffold") && 
        s.course_title.toLowerCase().includes(lvl === "level1" ? "level 1" : "level 2")
      );
    } else if (isWeld) {
      filtered = schedules.filter(s => 
        s.course_title.toLowerCase().includes("welding") && 
        s.course_title.toLowerCase().includes(lvl === "level1" ? "level 1" : "level 2")
      );
    } else if (isEF) {
      filtered = schedules.filter(s => 
        s.course_title.toLowerCase().includes("electrical") && 
        s.course_title.toLowerCase().includes(lvl === "level1" ? "level 1" : "level 2")
      );
    } else if (title.toLowerCase().includes("rigging") || title.toLowerCase().includes("signalling") || course.id === "104") {
      filtered = schedules.filter(s => 
        (s.course_title.toLowerCase().includes("rigging") || s.course_title.toLowerCase().includes("signalling")) && 
        s.course_title.toLowerCase().includes(lvl === "level1" ? "level 1" : "level 2")
      );
    }

    filtered = filtered.filter(s => {
      const sTitle = (s.course_title || "").toLowerCase();
      return !sTitle.includes("admin fee") && !sTitle.includes("adminfee");
    });

    if (lvl === "level1") {
      filtered = filtered.filter(s => s.course_run_for === "Public Class");
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    filtered = filtered.filter(s => {
      if (!s.start_date) return true;
      const startDate = new Date(s.start_date);
      return startDate >= today;
    });

    if (filtered.length === 0) {
      const mockDates = [
        { start: "2026-06-15", end: "2026-06-15", trainer: "Tan Cheng Lock" },
        { start: "2026-06-22", end: "2026-06-22", trainer: "Lim Ah Seng" },
        { start: "2026-07-06", end: "2026-07-06", trainer: "Mohamed Ali", isFull: true }
      ];

      filtered = mockDates.map((d, index) => ({
        schedule_id: `mock-${course.id}-${lvl}-${index}`,
        course_title: course.ITECoCTitle?.[lvl] || `${course.title} - ${targetLevelStr}`,
        course_code: `MOCK-${course.id}-${lvl.toUpperCase()}`,
        location_name: "PIONEER CENTRE #04-44",
        intake_no: `MOCK-${course.id}-${lvl.toUpperCase()}-202606-${index}`,
        course_language: "English",
        course_run_for: "Public Class",
        course_cost: lvl === "level1" ? "300.00" : "900.00",
        total_hours: lvl === "level1" ? 7 : 21,
        start_date: d.start,
        end_date: d.end,
        am_start_time: "09:00",
        pm_end_time: "17:00",
        max_trainee: 10,
        current_trainee: d.isFull ? 10 : 3,
        trainer: d.trainer
      }));
    }

    return filtered;
  };

  const hasSchedulePopup = course?.id && ["101", "102"].includes(course.id);

  const getMatchingProfile = useCallback((lvl) => {
    if (!course) return null;
    const titleLower = (course.title || "").toLowerCase();
    const isMS = titleLower.includes("scaffold") || course.id === "101";
    const isWeld = titleLower.includes("welding") || course.id === "102";
    const isEF = titleLower.includes("electrical") || course.id === "103";
    const isRig = titleLower.includes("rigging") || titleLower.includes("signalling") || course.id === "104";

    const isL1 = lvl === "level1";
    const isL2 = lvl === "level2";

    return profiles.find(p => {
      const pTitle = (p.course_title || p.name || "").toLowerCase();
      if (pTitle.includes("admin fee") || pTitle.includes("adminfee")) return false;
      let matchCourse = false;
      if (isMS && pTitle.includes("scaffold")) matchCourse = true;
      else if (isWeld && pTitle.includes("welding")) matchCourse = true;
      else if (isEF && pTitle.includes("electrical")) matchCourse = true;
      else if (isRig && (pTitle.includes("rigging") || pTitle.includes("signalling"))) matchCourse = true;

      if (!matchCourse) return false;

      if (isL1 && (pTitle.includes("level 1") || pTitle.includes("l1") || (!pTitle.includes("level 2") && !pTitle.includes("l2")))) return true;
      if (isL2 && (pTitle.includes("level 2") || pTitle.includes("l2"))) return true;

      return false;
    });
  }, [course, profiles]);

  const getPriceAndDurationForLevel = useCallback((lvl) => {
    if (!course) return { price: 0, duration: "" };
    const lvlData = course.levels[lvl];
    const profile = getMatchingProfile(lvl);

    const finalPrice = profile && profile.course_fee ? parseFloat(profile.course_fee) : lvlData.price;
    const finalDuration = profile && profile.total_hours ? `${profile.total_hours} Hours` : lvlData.duration;

    return { price: finalPrice, duration: finalDuration };
  }, [course, getMatchingProfile]);

  // Refs for GSAP animations
  const headerRef = useRef(null);
  const overviewRef = useRef(null);
  const fundingRef = useRef(null);
  const whoShouldAttendRef = useRef(null);
  const outcomesRef = useRef(null);
  const curriculumRef = useRef(null);
  const sidebarRef = useRef(null);

  useEffect(() => {
    if (course) {
      const lvl = course.levels[selectedLevel];
      const profile = getMatchingProfile(selectedLevel);

      // Price
      const finalPrice = profile && profile.course_fee ? parseFloat(profile.course_fee) : lvl.price;
      setPrice(finalPrice);

      // Duration
      const finalDuration = profile && profile.total_hours ? `${profile.total_hours} Hours` : lvl.duration;
      setDuration(finalDuration);

      // ITE CoC Title
      const finalIteTitle = profile && profile.course_title ? profile.course_title : (course.ITECoCTitle[selectedLevel] || "Not Available");
      setIteTitle(finalIteTitle);

      // Prerequisites
      const finalPrerequisites = profile && profile.prerequisites ? profile.prerequisites : (lvl.prerequisites || "None");
      setPrerequisites(finalPrerequisites);

      // Class Ratio
      const minT = profile ? (profile.min_class_size ?? profile.min_trainee ?? 1) : 1;
      const maxT = profile ? (profile.max_class_size ?? profile.max_trainee ?? 2) : 2;
      const finalClassRatio = profile ? `${minT}:${maxT}` : (lvl.classRatio || "1:2");
      setClassRatio(finalClassRatio);

      // Mode of Training
      const finalMode = profile && profile.mode_of_training ? profile.mode_of_training : (course.modeOfTraining || "Classroom Training");
      setModeOfTraining(finalMode);

      // Language
      const finalLang = profile && profile.language ? profile.language : (course.language || "English");
      setLanguage(finalLang);

      // Class Schedule
      const finalSchedule = profile && (profile.class_schedule || profile.start_date) ? (profile.class_schedule || profile.start_date) : (course.startDate || "Ongoing – Weekly");
      setClassSchedule(finalSchedule);
    }
  }, [course, selectedLevel, getMatchingProfile]);



  // GSAP Scroll Animations
  useEffect(() => {
    gsap.fromTo(
      headerRef.current,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: headerRef.current,
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play none none reverse",
        },
      }
    );

    gsap.fromTo(
      overviewRef.current,
      { x: -100, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "back.out(1.7)",
        scrollTrigger: {
          trigger: overviewRef.current,
          start: "top 85%",
          end: "bottom 20%",
          toggleActions: "play none none reverse",
        },
      }
    );

    gsap.fromTo(
      fundingRef.current,
      { scale: 0.8, opacity: 0, rotationY: 10 },
      {
        scale: 1,
        opacity: 1,
        rotationY: 0,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: fundingRef.current,
          start: "top 85%",
          end: "bottom 20%",
          toggleActions: "play none none reverse",
        },
      }
    );

    gsap.fromTo(
      whoShouldAttendRef.current,
      { y: 80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "elastic.out(1, 0.5)",
        scrollTrigger: {
          trigger: whoShouldAttendRef.current,
          start: "top 85%",
          end: "bottom 20%",
          toggleActions: "play none none reverse",
        },
      }
    );

    const outcomeItems = outcomesRef.current?.querySelectorAll("li");
    if (outcomeItems) {
      gsap.fromTo(
        outcomeItems,
        { x: -50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.15,
          ease: "power2.out",
          scrollTrigger: {
            trigger: outcomesRef.current,
            start: "top 85%",
            end: "bottom 20%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }

    const curriculumItems = curriculumRef.current?.querySelectorAll("li");
    if (curriculumItems) {
      gsap.fromTo(
        curriculumItems,
        { x: 50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: curriculumRef.current,
            start: "top 85%",
            end: "bottom 20%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }

    gsap.fromTo(
      sidebarRef.current,
      { opacity: 0, scale: 0.9 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: sidebarRef.current,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "play none none reverse",
        },
      }
    );

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, [course]);

  if (!course) {
    if (id && id.startsWith("api-") && profiles.length === 0) {
      return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
          <div className="w-16 h-16 border-4 border-green-100 border-t-[#0b9949] rounded-full animate-spin mb-6"></div>
          <p className="text-gray-500 font-medium animate-pulse">Loading course details...</p>
        </div>
      );
    }
    return (
      <div className="min-h-screen flex items-center justify-center text-3xl font-bold">
        Course Not Found
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <Navbar />

      {/* HEADER BANNER */}
      <section
        ref={headerRef}
        className="h-[480px] sm:h-[440px] bg-cover bg-center relative overflow-hidden"
      >
        <motion.img
          initial={{ scale: 1.2, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.3 }}
          src={course.bannerImage}
          alt={course.title}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/1200x330?text=Course+Banner";
          }}
        />

        {/* Overlay Title */}
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="absolute inset-0 bg-black/55 flex flex-col items-center justify-center gap-5 sm:gap-6 pt-24 sm:pt-28 md:pt-20 px-4"
        >
          <h1 className="text-white text-2xl sm:text-3xl md:text-5xl font-extrabold text-center max-w-4xl leading-tight px-2 sm:px-4">
            {course.title === "Certificate of Competency in Electrical Fitting"
              ? "Certificate of Competency in Electrical Fitting"
              : course.title}
          </h1>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center w-full max-w-[280px] sm:max-w-none">
            {/* ✅ Level 1 & Level 2 schedule buttons only for Metal Scaffold & Welding */}
            {hasSchedulePopup && (
              <>
                <motion.button
                  type="button"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => {
                    const dynamicData = getPriceAndDurationForLevel("level1");
                    navigate("/enroll", {
                      state: {
                        course,
                        selectedLevel: "level1",
                        price: dynamicData.price,
                        duration: dynamicData.duration,
                      }
                    });
                  }}
                  className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-full font-semibold text-sm md:text-base shadow-lg transition-all border-2 border-transparent hover:border-green-400 w-full sm:w-auto cursor-pointer"
                >
                  Level 1 Schedule
                </motion.button>

                <motion.button
                  type="button"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => {
                    const dynamicData = getPriceAndDurationForLevel("level2");
                    navigate("/enroll", {
                      state: {
                        course,
                        selectedLevel: "level2",
                        price: dynamicData.price,
                        duration: dynamicData.duration,
                      }
                    });
                  }}
                  className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-full font-semibold text-sm md:text-base shadow-lg transition-all border-2 border-transparent hover:border-green-400 w-full sm:w-auto cursor-pointer"
                >
                  Level 2 Schedule
                </motion.button>
              </>
            )}

            {/* Download Brochure – keeps existing behavior */}
            {course.brochureLink && (
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href={course.brochureLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-2.5 rounded-full font-bold text-sm md:text-base shadow-lg transition-all border-2 border-transparent hover:border-green-400 w-full sm:w-auto cursor-pointer"
              >
                <FaDownload />
                <span>Download Brochure</span>
              </motion.a>
            )}
          </div>
        </motion.div>
      </section>

      
      {/* MAIN GRID */}
      <div className="max-w-7xl mx-auto p-8 grid lg:grid-cols-3 gap-10">
        {/* LEFT CONTENT */}
        <div className="lg:col-span-2 space-y-10">
          {/* OVERVIEW */}
          <div ref={overviewRef} className="bg-white rounded-2xl p-10 shadow-lg">
            <h2 className="text-2xl font-bold">Course Overview</h2>
            <p className="mt-3 text-lg text-gray-700">{course.overview}</p>

            <div className="mt-6 p-4 bg-green-50 border-l-4 border-green-600 rounded">
              <p className="font-semibold text-green-900">Suitable For:</p>
              <p className="text-gray-700">{course.suitableFor}</p>
            </div>

            <div className="mt-6 space-y-3 text-lg">
              <p>
                <strong>ITE CoC Title:</strong> {iteTitle}
              </p>
              <div>
                <strong>Prerequisites:</strong>
                {Array.isArray(prerequisites) ? (
                  <ul className="list-disc list-inside pl-5 mt-1 text-base text-gray-700">
                    {prerequisites.map((req, index) => (
                      <li key={index}>{req}</li>
                    ))}
                  </ul>
                ) : (
                  <span className="ml-2">{prerequisites}</span>
                )}
              </div>
              <p>
                <strong>Mode of Training:</strong> {modeOfTraining}
              </p>
              <p>
                <strong>Language:</strong> {language}
              </p>
              <p>
                <strong>Class Schedule:</strong> {classSchedule}
              </p>
              <p className="text-sm text-gray-500 mt-2 italic">
                * Available classes are published weekly. Please contact us for
                the latest schedule.
              </p>
            </div>
          </div>

          {/* FUNDING INFO */}
          <div ref={fundingRef} className="bg-white rounded-2xl p-10 shadow-lg">
            <h2 className="text-2xl font-bold">Funding Information</h2>
            <ul className="mt-4 space-y-3 text-lg text-gray-700 leading-relaxed">
              <li>
                <strong>CERTIFIABLE COURSES – FUNDING SUPPORT</strong>
              </li>
              <li>
                SCs & PRs ≥ 21 yrs: <strong>Up to 50% subsidy</strong>
              </li>
              <li>
                SCs ≥ 40 yrs: <strong>Up to 70% subsidy</strong>
              </li>
              <li>
                SMEs: <strong>Up to 70% subsidy</strong>
              </li>
              <li>Baseline funding revised to 50% by SSG</li>
              <li>
                Enhanced schemes add <strong>20% higher subsidy</strong>
              </li>
              <li>
                Singaporeans 25+ may use <strong>SkillsFuture Credit</strong>
              </li>
              <li>
                Contact: <strong>62970118</strong>
              </li>
            </ul>
          </div>

          {/* WHO SHOULD ATTEND */}
          <div
            ref={whoShouldAttendRef}
            className="bg-white rounded-2xl p-10 shadow-lg"
          >
            <h2 className="text-2xl font-bold">Who Should Attend?</h2>
            <p className="mt-3 text-lg text-gray-700 leading-relaxed">
              New & existing workers in Process, Construction, Maintenance (PCM),
              Mechanical, Civil, Cleaning, Inspection & Safety roles.
            </p>
          </div>

          {/* OUTCOMES */}
          <div ref={outcomesRef} className="bg-white rounded-2xl p-10 shadow-lg">
            <h2 className="text-2xl font-bold">Learning Outcomes</h2>
            <ul className="mt-4 space-y-3 text-lg">
              {course.learningOutcomes.map((v, i) => (
                <li key={i} className="flex items-center gap-2">
                  <IoMdCheckmarkCircle className="text-green-600 text-xl" />
                  {v}
                </li>
              ))}
            </ul>
          </div>

          {/* CURRICULUM */}
          <div
            ref={curriculumRef}
            className="bg-white rounded-2xl p-10 shadow-lg"
          >
            <h2 className="text-2xl font-bold">Curriculum</h2>
            <ul className="mt-4 space-y-3 text-lg">
              {course.curriculum.map((v, i) => (
                <li key={i} className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-green-600 rounded-full"></span>
                  {v}
                </li>
              ))}
            </ul>
          </div>


        </div>

        {/* RIGHT PRICE BOX */}
        <div
          ref={sidebarRef}
          className="bg-white rounded-2xl p-8 shadow-2xl h-fit sticky top-28"
        >
          <h2 className="text-xl font-bold mb-4">Select Course Level</h2>

          <div className="flex gap-3">
            {["level1", "level2"].map((lvl) => (
              <button
                key={lvl}
                className={`px-5 py-2 rounded-lg font-bold transition-all ${selectedLevel === lvl
                  ? "bg-green-600 text-white shadow-md"
                  : "bg-gray-100 hover:bg-gray-200"
                  }`}
                onClick={() => setSelectedLevel(lvl)}
              >
                {lvl === "level1" ? "Level 1" : "Level 2"}
              </button>
            ))}
          </div>

          <div className="mt-6 space-y-2 text-gray-900 font-medium text-lg">
            <p className="flex items-center gap-2">
              <FaClock className="text-green-600" />
              <span>Duration:</span>
              <span className="font-semibold">{duration}</span>
            </p>

            <p className="flex items-center gap-2">
              <FaMoneyBillWave className="text-green-600" />
              <span>Course Fee:</span>
              <span className="font-extrabold text-green-700">${price}</span>
            </p>

            {classRatio && (
              <p className="flex items-center gap-2">
                <FaUserTie className="text-green-600" />
                <span>Class Ratio:</span>
                <span className="font-semibold">
                  {classRatio}
                </span>
              </p>
            )}
          </div>

          {/* ENROLL BUTTON */}
          <button
            onClick={() => {
              navigate("/enroll", {
                state: {
                  course,
                  selectedLevel,
                  price: price,
                  duration: duration,
                }
              });
            }}
            className="mt-7 w-full bg-green-700 hover:bg-green-800 text-white py-3 text-xl rounded-xl font-bold shadow-lg transition-all hover:scale-[1.02] active:scale-[0.98]"
          >
            Enroll Now
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
}
